import React from "react";
import { CSSTransition } from "react-transition-group";
import { IconTypes } from "@irati/ui/src/Icon";
import { ContentButtons, EditButtons, StyledContentHover } from "./styled";
var ContentHover = function (_a) {
    var handleEditTile = _a.handleEditTile, handleDeleteTile = _a.handleDeleteTile, isOnHover = _a.isOnHover;
    return (React.createElement(CSSTransition, { classNames: "homepage-edit-tile-overlay", in: isOnHover, timeout: {
            enter: 200,
            exit: 200
        }, unmountOnExit: true },
        React.createElement(StyledContentHover, null,
            React.createElement(ContentButtons, null,
                React.createElement(EditButtons, { icon: IconTypes.edit, onClick: function () { return handleEditTile(); } }),
                React.createElement(EditButtons, { icon: IconTypes.bin, onClick: function () { return handleDeleteTile(); } })))));
};
export default ContentHover;
